import PropTypes from 'prop-types';
import React from 'react';
// import moment from 'moment';
import { connect } from 'react-redux';
// import format from 'string-format';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DangerousHTMLDiv } from 'ecs-react-components/dist/index.es';
import { messages } from './SecureMessageReply.i18n';
import { loadLegalMessage, replyToSecureMessage } from '../../redux/modules/secure-message/secure-message-middleware';
import * as ACTIONS from '../../redux/modules/secure-message/actions/creators';
import { formatReplyToName } from './SecureMessagesConfig';

class SecureMessageReply extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isTextareaValid: true,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.legalMessage === null) {
      this.props.dispatch(loadLegalMessage(this.props.facilityId, this.props.languageCode));
    }
  }

  onReplyTextareaChange = () => {
    const replyText = this.textarea.value;
    if (replyText !== '' && this.state.isTextareaValid === false) {
      this.setState({ isTextareaValid: true });
    }
  }

  onSendButtonClick = () => {
    const { patientId, selectedThreadIndex, languageCode, timeZone, timeZoneOffset, dispatch, threads } = this.props;
    const replyText = this.textarea.value;
    if (replyText === '') {
      this.setState({ isTextareaValid: false });
      return;
    }

    const selectedThread = threads.find((x) => x.threadId === selectedThreadIndex);

    dispatch(replyToSecureMessage(
      patientId,
      selectedThread.threadId,
      replyText,
      languageCode,
      timeZone,
      timeZoneOffset));

    this.props.dispatch(ACTIONS.showSecureMessageReplyItem(false));
  }

  onCancelButtonClick = () => {
    this.props.dispatch(ACTIONS.showSecureMessageReplyItem(false));
  }

  render() {
    const { isVisible, threads, selectedThreadIndex } = this.props;
    const { formatMessage } = this.props.intl;

    const senderName = formatReplyToName(threads, selectedThreadIndex);
    const senderNameTag = 'sender-name';
    const formGroupClassName = this.state.isTextareaValid === false ? 'form-group has-error' : 'form-group';
    return (
      isVisible ?
      <li className="list-group-item message-reply-container clearfix">
        <span data-qa-item={ senderNameTag } className="primary-text bold">{ senderName }</span>
        {
          this.state.isTextareaValid === false ?
            (
              <span className="label label-danger header invalid-label">
              <FormattedMessage { ...messages.reply.required } />
              </span>
            ) :
            null
        }
        <div className={ formGroupClassName }>
          <textarea
            ref={ (textArea) => { this.textarea = textArea; } }
            className="form-control"
            rows="5"
            onChange={ this.onReplyTextareaChange }
            placeholder={ formatMessage(messages.replyTextboxPlaceholder) }
          >
          </textarea>
          <div className="utility-buttons">
              <button type="button" className="btn btn-primary me-1"
                onClick={ this.onSendButtonClick }
              >
                  <FormattedMessage { ...messages.reply.sendButton } />
              </button>
              <button type="button" className="btn btn-outline-secondary" onClick={ this.onCancelButtonClick }>
                  <FormattedMessage { ...messages.reply.cancelButton } />
              </button>
          </div>
          <div className="secondary-text">
            <DangerousHTMLDiv
              qaTag="legal-message"
              html={ this.props.legalMessage }
            />
          </div>
        </div>
      </li>
        : null
    );
  }
}

SecureMessageReply.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  intl: PropTypes.object,
  dispatch: PropTypes.func,
  legalMessage: PropTypes.string,
  facilityId: PropTypes.string,
  messagesToReplyTo: PropTypes.array,
  userId: PropTypes.string,
  isVisible: PropTypes.bool,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  languageCode: PropTypes.string,
  selectedThreadIndex: PropTypes.string,
  threads: PropTypes.array,
  patientId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  firstName: state.profile.user.firstName,
  lastName: state.profile.user.lastName,
  legalMessage: state.secureMessage.legalMessage,
  facilityId: state.facility.facilityId,
  patientId: state.profile.patient.patientId,
  messagesToReplyTo: state.secureMessage.messages,
  userId: state.profile.user.userId,
  isVisible: state.secureMessage.isReplyItemVisible,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  languageCode: state.language.languageCode,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  threads: state.secureMessage.threads,
});

export default connect(mapStateToProps)(injectIntl(SecureMessageReply));